// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"bubble__container___3sg0u","scale-in":"bubble__scale-in___2QgS1","scaleIn":"bubble__scale-in___2QgS1","right":"bubble__right___2VqI-","left":"bubble__left___KC0F5","scale-in-mobile":"bubble__scale-in-mobile___1va8T","scaleInMobile":"bubble__scale-in-mobile___1va8T"};
    if(module.hot) {
      // 1765244649360
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  